module.exports = __webpack_public_path__ + "static/media/icon-search.2e9ebfa7.svg";